// extracted by mini-css-extract-plugin
export default {"icon":"InventoryList_icon__2UnyP","arrowIcon":"InventoryList_arrowIcon__aU6Ee"};